module.exports = __webpack_public_path__ + "images/emoji/gun.f4d965aa60edd2d57767.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/gun.png
// module id = M2UP
// module chunks = 14